import { Box } from "@/common/components";
import { styled } from "@/stitches.config";
import { CSS } from "@stitches/react";

export const StyledReferencesContainer = styled(Box, {
  alignItems: 'center',
  display: 'flex',
  paddingLeft: '$8',
  width: '40%'
});

export const StyledChartContainer = styled(Box, {
  width: '60%'
});

export const StyledNoDataMessage = styled(Box, {
  alignItems: 'center',
  backgroundColor: '$coolGray600',
  borderRadius: '$8',
  color: '$darkGray400',
  display: 'flex',
  fontSize: '$lg',
  fontWeight: '$medium',
  height: '70%',
  justifyContent: 'center',
  margin: '10% 10% 10% 19%'
});

export const infoCardStyles: CSS = {
  padding: '0',
}

export const chartReferencesLabelStyles: CSS = {
  color: '$darkBlue400',
  fontSize: '$md',
  fontWeight: '$regular',
  lineHeight: '24px',
  marginBottom: '$3'
}

export const chartReferencesColumnStyles: CSS = {
  marginLeft: '0',
  width: '100%'
}
